import Upcoming from '~/components/Upcoming';

export const route = {
  preload: () => {},
} satisfies RouteDefinition;

export default function () {
  return <Upcoming />;
}
